/* sh-shestia-ui.js (module AJOUTS, 02/10/2026) : sites/shestia-sky-2026-09-26/shestia-actuel/shestia-ui.js, repris tel
   quel. Ses données (window.Shestia : produits, photos par couleur, esc…) viennent de snippets/sh-shestia-data.liquid. */
/* shestia-ui.js : composants partagés (24/09/2026).
   Un seul carrousel et un seul sélecteur couleur/taille pour l'accueil, la fiche, le quick view, le quiz,
   le closet et le panier : la même robe se choisit partout de la même façon et arrive identique au panier. */
(function () {
  'use strict';
  var S = window.Shestia;
  if (!S) return;
  var esc = S.esc;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Carrousel : flèches cliquables, aucune barre visible, une page = les cartes entièrement visibles.
     Tient 50 robes et plus : le défilement avance par page et le compteur dit où l'on est. */
  function rail(root) {
    if (!root || root._rail) return root && root._rail;
    var track = root.querySelector('[data-rail-track]'), prev = root.querySelector('[data-rail-prev]'),
        next = root.querySelector('[data-rail-next]'), count = root.querySelector('[data-rail-count]');
    if (!track) return null;
    function items() { return Array.prototype.filter.call(track.children, function (el) { return !el.hidden && el.getClientRects().length; }); }
    function metrics() {
      var list = items(), gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      if (!list.length) return {list: list, w: track.clientWidth, n: 1};
      var w = list[0].getBoundingClientRect().width + gap;
      return {list: list, w: w, n: Math.max(1, Math.floor((track.clientWidth + gap + 2) / w))};
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth, m = metrics(), total = m.list.length;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      root.classList.toggle('is-static', max <= 2);
      if (count) {
        var first = Math.min(total, Math.round(track.scrollLeft / m.w) + 1), last = Math.min(total, first + m.n - 1);
        count.textContent = total ? (first === last ? first : first + '–' + last) + ' of ' + total : '';
      }
    }
    function go(direction) {
      var m = metrics();
      track.scrollBy({left: direction * m.n * m.w, behavior: reduced.matches ? 'auto' : 'smooth'});
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, {passive: true});
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    window.addEventListener('resize', update);
    track.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', update, {once: true}); });
    var api = {update: update, reset: function () { track.scrollLeft = 0; update(); }, go: go};
    root._rail = api;
    update();
    return api;
  }
  function railHTML(opts) {
    return '<div class="sx-rail ' + (opts.className || '') + '" data-rail>' +
      '<div class="sx-rail__bar">' + (opts.head || '') +
      '<div class="sx-rail__nav"><span class="sx-rail__count" data-rail-count aria-live="polite"></span>' +
      '<button type="button" class="sx-arrow" data-rail-prev aria-label="Previous ' + esc(opts.label || 'items') + '">&#8592;</button>' +
      '<button type="button" class="sx-arrow" data-rail-next aria-label="Next ' + esc(opts.label || 'items') + '">&#8594;</button></div></div>' +
      '<div class="sx-rail__track" data-rail-track tabindex="0" aria-label="' + esc(opts.label || 'items') + '">' + (opts.items || '') + '</div></div>';
  }

  /* Image d'une robe dans un cadre qui prend le format natif de la photo : jamais de bande vide ni de silhouette coupée. */
  function setImage(img, p, colour, index) {
    if (!img || !p) return;
    var list = S.imagesFor(p, colour), src = list[index || 0] || S.imageFor(p, colour);
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    img.alt = list.length ? p.name + ' in ' + colour : 'No photo of ' + p.name + ' in ' + colour + ' yet';
    img.closest('[data-photo]') && img.closest('[data-photo]').classList.toggle('is-missing', !list.length);
  }
  /* Le cadre prend le format de la PREMIÈRE photo puis ne bouge plus : Naotag, 24/09 : « quand on sélectionne une
     variante sur la section the first edit l'image changer de format et ça fesait bouger la case ». Une couleur au
     format différent se loge dans le même cadre (fond clair, jamais de bande sombre). */
  function fitFrame(img) {
    function apply() {
      if (img.naturalWidth && img.naturalHeight) {
        var frame = img.closest('[data-photo]');
        if (frame && !frame.hasAttribute('data-ratio-fixed')) {
          frame.style.setProperty('--ratio', img.naturalWidth + ' / ' + img.naturalHeight); frame.style.setProperty('--r', (img.naturalWidth / img.naturalHeight).toFixed(4));
          frame.setAttribute('data-ratio-fixed', '');
        }
      }
    }
    img.addEventListener('load', apply);
    if (img.complete) apply();
  }

  /* Sélecteur : pastilles des couleurs fournisseur, tailles fournisseur, ajout au sac ou au closet. */
  function swatchesHTML(p, colour) {
    return '<div class="sx-swatches" role="radiogroup" aria-label="Colour for ' + esc(p.name) + '">' + p.variants.map(function (v) {
      var on = v.name === colour, missing = !S.hasPhoto(p, v.name);
      return '<button type="button" role="radio" aria-checked="' + on + '" class="sx-swatch' + (missing ? ' is-nophoto' : '') + '" data-pick-colour="' + esc(v.name) + '" title="' + esc(v.name) + (missing ? ' · no photo yet' : '') + '" style="--sw:' + esc(v.swatch) + '"><i></i><span class="sx-sr">' + esc(v.name) + '</span></button>';
    }).join('') + '</div>';
  }
  function sizesHTML(p, size) {
    return '<div class="sx-sizes" role="radiogroup" aria-label="Size for ' + esc(p.name) + '">' + p.sizes.map(function (z) {
      return '<button type="button" role="radio" aria-checked="' + (z === size) + '" class="sx-size" data-pick-size="' + esc(z) + '">' + esc(z) + '</button>';
    }).join('') + '</div>';
  }
  function pickerHTML(p, state, opts) {
    opts = opts || {};
    var colour = state && S.hasColour(p, state.colour) ? state.colour : p.colour, size = state && S.hasSize(p, state.size) ? state.size : '';
    var actions = opts.actions || ['bag', 'closet'];
    return '<div class="sx-pick' + (opts.compact ? ' sx-pick--compact' : '') + '" data-pick="' + esc(p.id) + '">' +
      '<div class="sx-pick__label"><span>Colour</span><b data-pick-colour-name>' + esc(colour) + '</b></div>' + swatchesHTML(p, colour) +
      '<p class="sx-pick__nophoto" data-pick-nophoto' + (S.hasPhoto(p, colour) ? ' hidden' : '') + '>No photo of this colour yet. The swatch shows the supplier colour.</p>' +
      '<div class="sx-pick__label"><span>Size</span>' + (opts.sizeGuide ? '<a class="sx-pick__guide" href="' + esc(opts.sizeGuide) + '">Size guide</a>' : '') + '</div>' + sizesHTML(p, size) +
      (p.sizeNote && opts.sizeNote !== false ? '<p class="sx-pick__note">' + esc(p.sizeNote) + '</p>' : '') +
      '<div class="sx-pick__actions">' +
      (actions.indexOf('bag') > -1 ? '<button type="button" class="sx-btn sx-btn--ink" data-pick-bag' + (size ? '' : ' disabled') + '>' + (size ? 'Add to bag' : 'Choose a size') + '</button>' : '') +
      (actions.indexOf('closet') > -1 ? '<button type="button" class="sx-btn sx-btn--line" data-pick-closet' + (size ? '' : ' disabled') + '>Add to closet</button>' : '') +
      '</div></div>';
  }
  /* Branche un sélecteur. opts.onColour(colour) met à jour les photos de la vue ; opts.onAdded(kind, selection). */
  function bindPicker(el, p, opts) {
    opts = opts || {};
    var state = {id: p.id, colour: (el.querySelector('[data-pick-colour][aria-checked="true"]') || {}).dataset ? el.querySelector('[data-pick-colour][aria-checked="true"]').dataset.pickColour : p.colour, size: ''};
    var chosen = el.querySelector('[data-pick-size][aria-checked="true"]');
    if (chosen) state.size = chosen.dataset.pickSize;
    function refresh() {
      el.querySelectorAll('[data-pick-colour]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.pickColour === state.colour)); });
      el.querySelectorAll('[data-pick-size]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.pickSize === state.size)); });
      var name = el.querySelector('[data-pick-colour-name]'); if (name) name.textContent = state.colour;
      var note = el.querySelector('[data-pick-nophoto]'); if (note) note.hidden = S.hasPhoto(p, state.colour);
      var bag = el.querySelector('[data-pick-bag]'), closet = el.querySelector('[data-pick-closet]');
      if (bag) { bag.disabled = !state.size; bag.textContent = state.size ? 'Add to bag' : 'Choose a size'; }
      if (closet) closet.disabled = !state.size;
    }
    el.addEventListener('click', function (e) {
      var c = e.target.closest('[data-pick-colour]'), z = e.target.closest('[data-pick-size]');
      if (c && el.contains(c)) { state.colour = c.dataset.pickColour; refresh(); if (opts.onColour) opts.onColour(state.colour); return; }
      if (z && el.contains(z)) { state.size = z.dataset.pickSize; refresh(); if (opts.onSize) opts.onSize(state.size); return; }
      var selection = {id: p.id, colour: state.colour, size: state.size, qty: 1};
      if (e.target.closest('[data-pick-bag]') && state.size) {
        if (opts.beforeAdd) opts.beforeAdd('bag', selection);
        if (window.ShestiaCart) window.ShestiaCart.add(selection);
        if (opts.onAdded) opts.onAdded('bag', selection);
      }
      if (e.target.closest('[data-pick-closet]') && state.size) {
        if (opts.beforeAdd) opts.beforeAdd('closet', selection);
        if (window.ShestiaCloset) window.ShestiaCloset.add(selection);
        if (opts.onAdded) opts.onAdded('closet', selection);
      }
    });
    el._pick = {state: state, set: function (colour, size) { if (S.hasColour(p, colour)) state.colour = colour; if (S.hasSize(p, size)) state.size = size; refresh(); if (opts.onColour) opts.onColour(state.colour); }};
    refresh();
    return el._pick;
  }

  /* Message court, avec une action facultative (ex. « View closet »). */
  var toastEl = null, toastTimer = 0;
  function toast(message, action) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sx-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + esc(message) + '</span>' + (action ? '<button type="button">' + esc(action.label) + '</button>' : '');
    if (action) toastEl.querySelector('button').onclick = function () { toastEl.classList.remove('is-on'); action.run(); };
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }

  /* Pictogramme de la livraison offerte (sac et fiche). */
  var truck = '<svg viewBox="0 0 28 28" aria-hidden="true"><path d="M3.5 8h13v11h-13zM16.5 12h5l3 3.5V19h-8z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="8.5" cy="20" r="2.2" fill="#FFFDFA" stroke="currentColor" stroke-width="1.5"/><circle cx="20.5" cy="20" r="2.2" fill="#FFFDFA" stroke="currentColor" stroke-width="1.5"/></svg>';

  window.ShestiaUI = {rail: rail, railHTML: railHTML, setImage: setImage, fitFrame: fitFrame, pickerHTML: pickerHTML, bindPicker: bindPicker,
    swatchesHTML: swatchesHTML, sizesHTML: sizesHTML, toast: toast, esc: esc, truck: truck};
})();
